import PropTypes from 'prop-types';
import React from 'react';
import { DOWNLOAD_PDF_HTML_STYLES } from './DeliveryIcons.DownloadPfdHtmlSyles';
import { DOWNLOAD_PDF_HTML_SANCTIONS_STYLES } from './DeliveryIcons.DownloadPfdHtmlSyles.Sanctions';
import EmailModal from './DeliveryIcons.EmailModal';
import { DELIVERY_ICONS_MODAL_INITIAL } from './DeliveryIcons.EmailModal';
import utils from './../../utils/utilities';
import { replace } from 'lodash';

export default class DeliveryIcons extends React.Component {

    static propTypes = {
        html: PropTypes.any
    };

    static defaultProps = {
        html: ''
    };

    constructor(props) {
        super(props);

        const today = new Date(),
              dd    = today.getDate(),
              mm    = today.getMonth() + 1,
              yyyy  = today.getFullYear();

        this.state = {
            modalState:      null,
            pdfContent:      '',
            htmlToPdfFormId: 'htmlToPdfForm-' + utils.generateRandomHash(),
            attachmentName:  `LexisNexis-EntityInsight-Article-${yyyy}-${mm}-${dd}.pdf`,
        };

        this.openModal = this.openModal.bind(this);
        this.startDownload = this.startDownload.bind(this);
        this.setModalState = this.setModalState.bind(this);
    }

    openModal() {
        this.setState({modalState: DELIVERY_ICONS_MODAL_INITIAL});
    }

    setModalState(state) {
        this.setState({modalState: state});
    }

    startDownload() {
        document.getElementById(this.state.htmlToPdfFormId).submit();
    }

    componentDidMount() {

        if (this.props.html) {

            let downloadablePdfHtml = this.props.html;

            downloadablePdfHtml = replace(downloadablePdfHtml, /<\/head>/g, '<style>' + DOWNLOAD_PDF_HTML_SANCTIONS_STYLES + '</style><\/head>');

            let eiHeader = `<div class="header-ei"><div class="header-ei__menu-wrapper"><a class="header-ei__logo" href="#/start"><div class="header-ei__logo--company"><span class="notranslate formatted-message">Nexis</span><sup>®</sup></div><div class="header-ei__logo--product"><span class="notranslate formatted-message">Entity Insight</span></div></a><div class="header-ei__placeholder"><div class="submenu no-print"></div></div></div></div>`;
            downloadablePdfHtml = replace(downloadablePdfHtml, /<body>/g, '<body>' + eiHeader);

            let source = document.getElementsByClassName('sanction-reports__page-content--source-information')[0].outerHTML;
            downloadablePdfHtml = replace(downloadablePdfHtml, /<\/body>/g, '<div class="pagebreak">' + source + '<\/div><\/body>');

            this.setState({pdfContent: downloadablePdfHtml});

            return;

        }

        if(this.props.experianHtml) {
            let downloadablePdfHtml = this.props.experianHtml;
            downloadablePdfHtml = replace(downloadablePdfHtml, /<\/head>/g, '<style>' + DOWNLOAD_PDF_HTML_SANCTIONS_STYLES + '</style><\/head>');
            let eiHeader = `<div class="header-ei"><div class="header-ei__menu-wrapper"><a class="header-ei__logo" href="#/start"><div class="header-ei__logo--company"><span class="notranslate formatted-message">Nexis</span><sup>®</sup></div><div class="header-ei__logo--product"><span class="notranslate formatted-message">Entity Insight</span></div></a><div class="header-ei__placeholder"><div class="submenu no-print"></div></div></div></div>`;
            downloadablePdfHtml = replace(downloadablePdfHtml, /<body>/g, '<body>' + eiHeader);
            this.setState({pdfContent: downloadablePdfHtml});
            return;
        }

        let styles = DOWNLOAD_PDF_HTML_STYLES;

        //article body
        let source = document.getElementsByClassName('article-body__source')[0];
        source = source ? document.getElementsByClassName('article-body__source')[0].outerHTML : '';

        let headline = document.getElementsByClassName('article-body__headline')[0];
        headline = headline ? document.getElementsByClassName('article-body__headline')[0].outerHTML : '';

        let dateAuthor = document.getElementsByClassName('article-body__date-author')[0];
        dateAuthor = dateAuthor ? document.getElementsByClassName('article-body__date-author')[0].outerHTML : '';

        let content = document.getElementsByClassName('article-body__content')[0];
        content = content ? document.getElementsByClassName('article-body__content')[0].outerHTML : '';

        let url = document.getElementsByClassName('article-body__url')[0];
        url = url ? document.getElementsByClassName('article-body__url')[0].outerHTML : '';

        let copyright = document.getElementsByClassName('article-body__copyright')[0];
        copyright = copyright ? document.getElementsByClassName('article-body__copyright')[0].outerHTML : '';

        //article details
        let entitiesMentionedHeader = document.getElementsByClassName('article-details__section-third-parties')[0];
        entitiesMentionedHeader = entitiesMentionedHeader ?
            document.getElementsByClassName('article-details__section-third-parties')[0].outerHTML : '';

        let riskAngleMatchesHeader = document.getElementsByClassName(
            'article-details__section-risk-angle-matches')[0];
        riskAngleMatchesHeader = riskAngleMatchesHeader ?
            document.getElementsByClassName('article-details__section-risk-angle-matches')[0].outerHTML : '';

        let aboutThisArticleHeader = document.getElementsByClassName('article-details__section-about')[0];
        aboutThisArticleHeader = aboutThisArticleHeader ?
            document.getElementsByClassName('article-details__section-about')[0].outerHTML : '';
        aboutThisArticleHeader = aboutThisArticleHeader.replace(/&nbsp;/g, '');

        let downloadablePdfHtml = `
            <!DOCTYPE html>
            <html>
            <head>
            <style>${styles}</style>
            </head>
            <body>            
            <div class="header"><div class="header__menu-wrapper"><a class="header__logo" href="#/start"><div class="header__logo--company"><span class="notranslate formatted-message">Nexis</span><sup>®</sup></div><div class="header__logo--product"><span class="notranslate formatted-message">Entity Insight</span></div></a><div class="header__placeholder"><div class="submenu no-print"></div></div></div></div>                                                           
            <div class="article-body">
                ${source}
                ${headline}
                ${dateAuthor}
                ${content}
                ${url}
                ${copyright}
                
            </div>           
            <div class="article-details">
                ${entitiesMentionedHeader}
                ${riskAngleMatchesHeader}
                ${aboutThisArticleHeader}                
            </div>        
            </body>
            </html>`;

        downloadablePdfHtml = replace(downloadablePdfHtml, /<br>/g, '<br/>');

        this.setState({pdfContent: downloadablePdfHtml});
    }

    render() {

        return (
            <div className="delivery-icons no-print notranslate">

                <span className="la-Print" onClick={window.print} />

                <span className="la-Email" onClick={this.openModal} />
                <EmailModal modalState={this.state.modalState}
                            pdfContent={this.state.pdfContent}
                            setModalState={this.setModalState} />

                <span className="la-Download" onClick={this.startDownload} />
                <form action="/api/download/html-to-pdf/" method="post" id={this.state.htmlToPdfFormId}>
                    <input type="hidden" name="html" value={this.state.pdfContent}></input>
                    <input type="hidden" name="attachmentName" value={this.state.attachmentName}></input>
                </form>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/DeliveryIcons/DeliveryIcons.jsx